<script>
    
    import { toast } from 'bulma-toast'
    import { pricesStore, modalStore } from '../stores'
    
    import PricesService from '../$services/prices.service'

    import Button from '../$components/button.svelte'
    import InputNumber from '../$components/input.number.svelte'
    import Providers from '../$components/providers.svelte'
    import Select from '../$components/select.svelte'
    import Form from '../$components/form.svelte'
    import Date from '../$components/date.svelte'
    import InputPricingTag from '../$components/input.pricing.tag.svelte'

    export let userId = null

    let loading = false
    let kind = 'public'
    let tag = ''
    let data = {
        userId,
        type: userId? 'user' : 'public',
    }

    async function createPrice() {

        // sin userId el precio es público o de una etiqueta de precios (users.pricingTag)
        if(!userId)
            data.type = kind === 'tag'? tag : 'public'

        loading = true
        const resp = await PricesService.createPrice(data)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        pricesStore.append(resp.data)
        modalStore.close()
    }

</script>

<Form on:submit={createPrice} { loading } >

    {#if !userId}
        <div class="columns">
            <div class="column">
                <Select
                    bind:value={kind}
                    label="Tipo"
                    options={[
                        {value: 'public', text: 'Público'},
                        {value: 'tag', text: 'Etiqueta de precios'},
                    ]}
                />
            </div>
        </div>
        {#if kind === 'tag'}
            <div class="columns">
                <div class="column">
                    <InputPricingTag bind:value={tag} required />
                </div>
            </div>
        {/if}
    {/if}

    <Providers bind:provider={data.provider} bind:service={data.service} />

    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.volumetricMin} label="Peso mínimo" placeholder="Peso mínimo" />
        </div>
        <div class="column">
            <InputNumber bind:value={data.volumetricMax} label="Peso máximo" placeholder="Peso máximo" />
        </div>
    </div>

    <Select 
        bind:value={data.pricing}
        label="Pricing"
        options={[
            {value: 'price', text: 'Precio'},
            {value: 'percent', text: 'Porcentaje'},
            {value: 'amount', text: 'Monto'},
        ]}
    />

    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.value} label="Valor" placeholder="Valor" />
        </div>
    </div>

    {#if data.type === 'user'}
        <div class="columns">
            <div class="column">
                <Date bind:value={data.expired} label="Fecha de expiración" />
            </div>
        </div>
    {/if}

    <div class="items-end">
        <div class="buttons">
            <Button on:click={modalStore.close} text="Cancelar" icon="ban" color="light"/>
            <Button type="submit" text="Guardar" icon="save" color="primary" {loading}/>
        </div>
    </div>
</Form>